"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOutlookRecipients = exports.getEmails = exports.setRecipientsEmails = exports.setRecipientsEmail = exports.getSubject = exports.setSubject = exports.setBodyHTML = exports.clearBody = exports.getBody = void 0;
function getBody() {
    return new Promise((resolve) => {
        try {
            if (!window?.Office?.context?.mailbox?.item?.body?.getAsync)
                return resolve({ status: Office.AsyncResultStatus.Failed, body: '', error: 'API error' });
            window.Office.context.mailbox.item.body.getAsync(Office.CoercionType.Html, (asyncResult) => {
                if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                    return resolve({ status: asyncResult.status, body: '', error: asyncResult.error.message });
                }
                resolve({ status: asyncResult.status, body: asyncResult.value });
            });
        }
        catch (error) {
            console.error('Error: ' + error);
            resolve({ status: Office.AsyncResultStatus.Failed, body: '', error: 'Error getting body' });
        }
    });
}
exports.getBody = getBody;
function clearBody() {
    return new Promise((resolve) => {
        try {
            if (!window?.Office?.context?.mailbox?.item?.body?.setAsync)
                return resolve({ status: Office.AsyncResultStatus.Failed, error: 'API error' });
            window.Office.context.mailbox.item.body.setAsync('', { coercionType: window.Office.CoercionType.Html }, (asyncResult) => {
                if (asyncResult.status === window?.Office?.AsyncResultStatus.Failed) {
                    return resolve({ status: asyncResult.status, error: asyncResult.error.message });
                }
                resolve({ status: asyncResult.status });
            });
        }
        catch (error) {
            console.error('Error: ' + error);
            resolve({ status: Office.AsyncResultStatus.Failed, error: 'Error setting body' });
        }
    });
}
exports.clearBody = clearBody;
function setBodyHTML(html) {
    return new Promise((resolve) => {
        try {
            if (!window?.Office?.context?.mailbox?.item?.body?.setAsync)
                return resolve({ status: Office.AsyncResultStatus.Failed, error: 'API error' });
            window.Office.context.mailbox.item.body.setAsync(html, { coercionType: window.Office.CoercionType.Html }, (asyncResult) => {
                if (asyncResult.status === window?.Office?.AsyncResultStatus.Failed) {
                    return resolve({ status: asyncResult.status, error: asyncResult.error.message });
                }
                resolve({ status: asyncResult.status });
            });
        }
        catch (error) {
            console.error('Error: ' + error);
            resolve({ status: Office.AsyncResultStatus.Failed, error: 'Error setting body' });
        }
    });
}
exports.setBodyHTML = setBodyHTML;
function setSubject(text) {
    return new Promise((resolve) => {
        try {
            if (!window?.Office?.context?.mailbox?.item?.subject?.setAsync)
                return resolve({ status: Office.AsyncResultStatus.Failed, error: 'API error' });
            window.Office.context.mailbox.item.subject.setAsync(text, (asyncResult) => {
                if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
                    return resolve({ status: asyncResult.status, error: asyncResult.error.message });
                }
                resolve({ status: asyncResult.status });
            });
        }
        catch (error) {
            console.error('Error: ' + error);
            resolve({ status: Office.AsyncResultStatus.Failed, error: 'Error setting subject' });
        }
    });
}
exports.setSubject = setSubject;
function getSubject() {
    return new Promise((resolve) => {
        try {
            if (!window?.Office?.context?.mailbox?.item?.subject?.getAsync)
                return resolve({ status: Office.AsyncResultStatus.Failed, subject: '', error: 'API error' });
            window.Office.context.mailbox.item.subject.getAsync((asyncResult) => {
                if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                    return resolve({ status: asyncResult.status, subject: '', error: asyncResult.error.message });
                }
                resolve({ status: asyncResult.status, subject: asyncResult.value });
            });
        }
        catch (error) {
            console.error('Error: ' + error);
            resolve({ status: Office.AsyncResultStatus.Failed, subject: '', error: 'Error getting subject' });
        }
    });
}
exports.getSubject = getSubject;
function setRecipientsEmail(recipientType, contacts = []) {
    return new Promise((resolve) => {
        try {
            if (!window?.Office?.context?.mailbox?.item?.[recipientType]?.setAsync)
                return resolve({ status: Office.AsyncResultStatus.Failed, error: 'API error' });
            const recipients = contacts.map((email) => ({ emailAddress: email.emailAddress, displayName: email.name }));
            window.Office.context.mailbox.item[recipientType].setAsync(recipients, (asyncResult) => {
                if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
                    return resolve({ status: asyncResult.status, error: asyncResult.error.message });
                }
                resolve({ status: asyncResult.status });
            });
        }
        catch (error) {
            console.error('Error: ' + error);
            resolve({ status: Office.AsyncResultStatus.Failed, error: 'Error setting recipients' });
        }
    });
}
exports.setRecipientsEmail = setRecipientsEmail;
async function setRecipientsEmails(recipients) {
    try {
        const { status: toStatus, error: toError } = await setRecipientsEmail('to', recipients.TO);
        const { status: ccStatus, error: ccError } = await setRecipientsEmail('cc', recipients.CC);
        const { status: bccStatus, error: bccError } = await setRecipientsEmail('bcc', recipients.BCC);
        return {
            status: Office.AsyncResultStatus.Succeeded,
            statuses: { TO: toStatus, CC: ccStatus, BCC: bccStatus },
            errors: { TO: toError, CC: ccError, BCC: bccError },
        };
    }
    catch (error) {
        console.error('Error: ' + error);
        return { status: Office.AsyncResultStatus.Failed, error: 'Error setting recipients' };
    }
}
exports.setRecipientsEmails = setRecipientsEmails;
function getEmails(recipientType) {
    return new Promise((resolve) => {
        let contacts = [];
        try {
            if (!window?.Office?.context?.mailbox?.item?.[recipientType]?.getAsync)
                return resolve({ status: Office.AsyncResultStatus.Failed, contacts, error: 'API error' });
            window.Office.context.mailbox.item[recipientType].getAsync((asyncResult) => {
                if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
                    return resolve({ status: asyncResult.status, contacts, error: asyncResult.error.message });
                }
                contacts = asyncResult.value.map((recipient) => ({
                    emailAddress: recipient.emailAddress,
                    name: recipient.displayName,
                }));
                resolve({ status: asyncResult.status, contacts });
            });
        }
        catch (error) {
            console.error('Error: ' + error);
            resolve({ status: Office.AsyncResultStatus.Failed, contacts, error: 'Error getting recipients' });
        }
    });
}
exports.getEmails = getEmails;
async function getOutlookRecipients() {
    try {
        const { status: toStatus, contacts: toContacts } = await getEmails('to');
        const { status: ccStatus, contacts: ccContacts } = await getEmails('cc');
        const { status: bccStatus, contacts: bccContacts } = await getEmails('bcc');
        return {
            status: Office.AsyncResultStatus.Succeeded,
            statuses: { TO: toStatus, CC: ccStatus, BCC: bccStatus },
            contacts: { TO: toContacts, CC: ccContacts, BCC: bccContacts },
        };
    }
    catch (error) {
        console.error('Error: ' + error);
        return {
            error: 'Error getting recipients: ' + (error instanceof Error ? error.message : String(error)),
            status: Office.AsyncResultStatus.Failed,
            statuses: {
                TO: Office.AsyncResultStatus.Failed,
                CC: Office.AsyncResultStatus.Failed,
                BCC: Office.AsyncResultStatus.Failed,
            },
            contacts: { TO: [], CC: [], BCC: [] },
        };
    }
}
exports.getOutlookRecipients = getOutlookRecipients;
